import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SiteNav, SiteFooter } from "../components/SiteChrome";
import { POSTS, formatPostDate } from "../blog/posts";
import {
  HERO_INNER_MAX,
  FONT_WEIGHT_SEMIBOLD,
} from "../lib/constants";

export default function BlogIndex() {
  useEffect(() => {
    document.title = "Blog | HOL Creative Solutions";
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <div data-testid="blog-index-page">
      <SiteNav activeKey="blog" />

      {/* HERO */}
      <section className="hero cinematic editorial" data-testid="blog-hero">
        <div className="hero-grain" />
        <div className="hero-glow" />
        <div className="hero-inner" style={{ maxWidth: HERO_INNER_MAX.blogIndex }}>
          <div className="hero-eyebrow">HOL Field Notes</div>
          <h1 data-testid="blog-heading">
            Notes on operations, ventures &amp;{" "}
            <em>building things that run.</em>
          </h1>
          <p className="hero-sub">
            Practical writing on property service ventures, real estate operations,
            procurement, and the systems that make small businesses actually scale.
          </p>
        </div>
      </section>

      <div className="cinema-stage">
      {/* POSTS LIST */}
      <section className="hol-section" data-testid="blog-posts-section">
        <div className="section-label">Latest</div>
        <h2 className="section-title">Articles.</h2>
        <p className="section-sub">
          One post at a time. No filler.
        </p>

        {POSTS.length === 0 ? (
          <p style={{ color: "var(--text-muted)" }} data-testid="blog-empty">
            New posts coming soon.
          </p>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", maxWidth: HERO_INNER_MAX.blogPostsGrid }}
            data-testid="blog-posts-grid"
          >
            {POSTS.map((p, i) => (
              <article
                key={p.slug}
                className="blog-card-editorial reveal-on-scroll"
                style={{ display: "flex", flexDirection: "column", gap: 12 }}
                data-testid={`blog-post-card-${i}`}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    fontSize: "0.72rem",
                    color: "var(--text-muted)",
                    fontWeight: FONT_WEIGHT_SEMIBOLD,
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                  }}
                >
                  <span
                    style={{ color: "var(--green-accent)" }}
                    data-testid={`blog-post-category-${i}`}
                  >
                    {p.category}
                  </span>
                  <span style={{ opacity: 0.4 }}>·</span>
                  <span data-testid={`blog-post-date-${i}`}>{formatPostDate(p.date)}</span>
                </div>
                <h3
                  style={{
                    fontFamily: "var(--font-display)",
                    fontSize: "clamp(1.6rem, 2.6vw, 2.2rem)",
                    margin: 0,
                    lineHeight: 1.15,
                    fontWeight: 400,
                    letterSpacing: "-0.015em",
                  }}
                >
                  <Link
                    to={`/blog/${p.slug}`}
                    style={{ color: "inherit", textDecoration: "none" }}
                    data-testid={`blog-post-title-${i}`}
                  >
                    {p.title}
                  </Link>
                </h3>
                <p style={{ fontSize: "1rem", margin: 0, lineHeight: 1.7, maxWidth: "60ch" }}>
                  {p.excerpt}
                </p>
                <Link
                  to={`/blog/${p.slug}`}
                  style={{
                    marginTop: 6,
                    color: "var(--green-accent)",
                    fontWeight: FONT_WEIGHT_SEMIBOLD,
                    fontSize: "0.85rem",
                    textDecoration: "none",
                    letterSpacing: "0.06em",
                  }}
                  data-testid={`blog-post-link-${i}`}
                >
                  Read article →
                </Link>
              </article>
            ))}
          </div>
        )}
      </section>
      </div>

      <SiteFooter />
    </div>
  );
}
